// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__396YX","type":"styles_type__23S_-","choices":"styles_choices__3GdIS"};